import { FormValidationMessage } from '../FormValidationMessage';

export type SelectOption = {
  value: string;
  label: string;
};

type Attributes = Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  'className'
>;

export const FormSelectOption: React.FC<
  {
    label: string;
    optionValues: SelectOption[];
    validationMessage?: string | undefined;
    isValidationError?: boolean; // for red border without error message
  } & Attributes
> = ({
  label,
  optionValues,
  validationMessage,
  isValidationError = false,
  ...attr
}) => (
  <div>
    <div
      className={
        validationMessage || isValidationError
          ? 'relative overflow-hidden rounded-2 border-2 border-caution-primary'
          : 'relative overflow-hidden rounded-2 border-2 border-main-10 focus-within:border-main-40'
      }
    >
      <div className="absolute inset-0 bg-base-100" />
      <select
        {...attr}
        className="relative block h-14 w-full appearance-none bg-base-100 pl-4 pr-8 pt-5 font-[600] text-main-100 outline-hidden"
      >
        {optionValues.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <label className="pointer-events-none absolute inset-x-4 top-2 truncate text-base3 font-[600] leading-[1] text-main-80">
        {label}
      </label>
      <div className="pointer-events-none absolute inset-y-0 right-4 my-auto size-2 rotate-45 border-b-2 border-r-2 border-main-80" />
    </div>
    {validationMessage && (
      <FormValidationMessage validateMessage={validationMessage} />
    )}
  </div>
);
